import React from "react";
import { Link } from "react-router-dom";
import { LogoMark } from "./Nav";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-coal/40">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <LogoMark className="w-9 h-9" />
              <span className="font-display font-extrabold tracking-tight text-xl">01 LONDON</span>
            </div>
            <p className="text-ash text-sm leading-relaxed max-w-xs">
              Premium minimal streetwear, exclusively made in London. Heavyweight essentials for those who choose substance over hype.
            </p>
            <a href="mailto:info@01london.co.uk" className="inline-block mt-6 font-mono text-[11px] tracking-[0.18em] text-bone border-b border-white/20 hover:border-ember hover:text-ember pb-1 transition-colors" data-testid="footer-email-link">
              INFO@01LONDON.CO.UK
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.25em] text-ash uppercase mb-5">Shop</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/shop" className="hover:text-ash transition-colors" data-testid="footer-shop-all">All products</Link></li>
              <li><Link to="/product/01-premium-oversized-hoodie" className="hover:text-ash transition-colors">Signature Hoodie</Link></li>
              <li><Link to="/product/01-icon-oversized-hoodie" className="hover:text-ash transition-colors">Icon Hoodie</Link></li>
              <li><Link to="/product/01-signature-trucker-cap" className="hover:text-ash transition-colors">Trucker Cap</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.25em] text-ash uppercase mb-5">Help</p>
            <ul className="space-y-3 text-sm">
              <li><a href="/#faq" className="hover:text-ash transition-colors">FAQ</a></li>
              <li><Link to="/policies/shipping-policy" className="hover:text-ash transition-colors" data-testid="footer-shipping-policy">Shipping policy</Link></li>
              <li><Link to="/policies/refund-policy" className="hover:text-ash transition-colors" data-testid="footer-refund-policy">Refund &amp; returns</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.25em] text-ash uppercase mb-5">The promise</p>
            <ul className="space-y-3 text-sm text-bone/80">
              <li>Free UK delivery over £75</li>
              <li>Dispatched within 48 hours</li>
              <li>14-day returns</li>
              <li>Secure checkout via Shopify</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.14em] text-ash uppercase">© {new Date().getFullYear()} 01 LONDON — All rights reserved</p>
          <div className="flex flex-wrap items-center gap-5 font-mono text-[10px] tracking-[0.14em] uppercase text-ash">
            <Link to="/policies/terms-of-service" className="hover:text-bone transition-colors" data-testid="footer-terms">Terms</Link>
            <Link to="/policies/privacy-policy" className="hover:text-bone transition-colors" data-testid="footer-privacy">Privacy</Link>
            <Link to="/policies/contact-information" className="hover:text-bone transition-colors" data-testid="footer-contact">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
